import React, {Component} from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {connect} from "react-redux";
//internal imports
import * as actions from "../../actions";
import className from 'classnames';
import {hideModal, isEmpty, showModal, vuepayAlert, vuePayLog} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";
import {getUserDetailsFromAPI} from "../../util/account_management";
import loading_white from '../../assets/gif/loading_white.gif';
import {getBlob} from "../../util/broadcaster/profile_util";

class ChannelPictureModal extends Component {

    constructor() {
        super();

        this.state = {
            type: "broadcaster_channel_image",//broadcaster_profile_pic,user_profile_pic,
            src: null,
            crop: {
                unit: '%',
                width: 400,
                aspect: 16 / 9,
                image: null,
                channel_pic_rectangle: null,
                channel_pic_square: null
            },
        };

        //all the functions used in this component should be listed here for better documentation
        this.onSelectFile = this.onSelectFile.bind(this);
        this.onImageLoaded = this.onImageLoaded.bind(this);
        this.onCropComplete = this.onCropComplete.bind(this);
        this.onCropChange = this.onCropChange.bind(this);
        this.makeClientCrop = this.makeClientCrop.bind(this);
        this.getCroppedImg = this.getCroppedImg.bind(this);
        this.uploadChannelImage = this.uploadChannelImage.bind(this);

        this.getCroppedImg = this.getCroppedImg.bind(this);
        this.getSquareCroppedImg = this.getSquareCroppedImg.bind(this);
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.broadcasterChannelPicture.hasOwnProperty("payload")
            && nextProps.broadcasterChannelPicture.payload !== null) {

            if (nextProps.broadcasterChannelPicture.payload.hasOwnProperty("data") &&
                nextProps.broadcasterChannelPicture.payload.data !== null &&
                nextProps.broadcasterChannelPicture.payload.data.length > 0) {

                this.props.setUserDetails(nextProps.broadcasterChannelPicture.payload.data[0])
                this.resetUploadImage()
            }

            if (nextProps.broadcasterChannelPicture.payload.hasOwnProperty("status_code")) {
                const message = nextProps.broadcasterChannelPicture.payload.message;
                nextProps.resetUploadChannelPicture();
                if (nextProps.broadcasterChannelPicture.payload.status_code === 200) {
                    vuepayAlert("success", message, () => {
                        getUserDetailsFromAPI(this.props)
                    })
                } else {
                    vuepayAlert("error", message)
                }
                this.resetUploadImage()
            }
        }

        if (nextProps.broadcasterProfilePicture.hasOwnProperty("payload")
            && nextProps.broadcasterProfilePicture.payload !== null) {

            if (nextProps.broadcasterProfilePicture.payload.hasOwnProperty("data") &&
                nextProps.broadcasterProfilePicture.payload.data !== null &&
                nextProps.broadcasterProfilePicture.payload.data.length > 0) {

                this.props.setUserDetails(nextProps.broadcasterProfilePicture.payload.data[0])
                this.resetUploadImage()
            }

            if (nextProps.broadcasterProfilePicture.payload.hasOwnProperty("status_code")) {
                const message = nextProps.broadcasterProfilePicture.payload.message;
                nextProps.resetUploadBroadcastProfilePicture();
                if (nextProps.broadcasterProfilePicture.payload.status_code === 200) {
                    vuepayAlert("success", message, () => {
                        getUserDetailsFromAPI(this.props)
                    })
                } else {
                    vuepayAlert("error", message)
                }
                this.resetUploadImage()
            }
        }

        if (nextProps.account_management.uploadProfilePicture) {
            if (nextProps.account_management.uploadProfilePicture.status_code === 200) {
                nextProps.resetProfilePicture();

                vuepayAlert("success", nextProps.account_management.uploadProfilePicture.message, () => {
                    getUserDetailsFromAPI(this.props)
                });
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                vuepayAlert("error", nextProps.account_management.uploadProfilePicture.message);
            }
            this.resetUploadImage()
        }

    }

    /**
     * @function removes the image from the file
     */
    resetUploadImage = () => {
        this.setState({
            image: null
        }, () => {
            hideModal(document.getElementById(this.props.id))
        })
    };

    onSelectFile = e => {

        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({src: reader.result})
            );
            reader.readAsDataURL(e.target.files[0]);
            this.setState({
                image: e.target.files[0]
            });


            this.setState({
                crop:{
                    type: this.props.type,//broadcaster_channel_image,broadcaster_profile_pic,user_profile_pic,
                    aspect: this.props.type === "broadcaster_channel_image" ? 16 / 9 : 1 / 1,
                    circularCrop: this.props.type !== "broadcaster_channel_image",
                    // width: this.props.type === "broadcaster_channel_image" ? 400 : 300,
                    // height: this.props.type === "broadcaster_channel_image" ? undefined : 300,
                    locked: this.props.type !== "broadcaster_channel_image",
                    unit: '%',
                    ruleOfThirds: false,
                    crossorigin: true,
                    x: 0,
                    y: 0,
                    width: 50,
                    height: 50
                }
            }, () => {
                showModal(document.getElementById(this.props.id))
            });

        }
    };

    // If you setState the crop in here you should return false.
    onImageLoaded = img => {

        this.imageRef = img;

        let aspect = 1 / 1, width = 50, height = 50, x = 0, y = 0;

        if (this.props.type === "broadcaster_channel_image") {
            aspect = 16 / 9;
            width = img.width > img.height ? 100 : ((img.height * aspect) / img.width) * 100;
            height = img.height > img.width ? 100 : (img.width / aspect / img.height) * 100;
            y = (100 - height) / 2;
            x = (100 - width) / 2;
        } else {
            width = img.width > img.height ? (img.height / img.width) * 100 : 100;
            height = img.height > img.width ? (img.width / img.height) * 100 : 100;
            x = width === 100 ? 0 : (100 - width) / 2;
            y = height === 100 ? 0 : (100 - height) / 2;
        }

        this.setState({
            crop: {
                type: this.props.type,//broadcaster_channel_image,broadcaster_profile_pic,user_profile_pic,
                aspect: this.props.type === "broadcaster_channel_image" ? 16 / 9 : 1,
                // width: this.props.type === "broadcaster_channel_image" ? 400 : 300,
                // height: this.props.type === "broadcaster_channel_image" ? undefined : 300,
                unit: '%',
                width,
                height,
                x,
                y,
            }
        }, () => {
            showModal(document.getElementById(this.props.id));
        });

        return false;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({crop});
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            if (this.props.type === "broadcaster_channel_image") {
                this.getCroppedImg(
                    this.imageRef,
                    crop,
                    (blob) => {
                        this.setState({
                            channel_pic_rectangle: blob
                        })
                    }
                );

                this.getSquareCroppedImg(
                    this.imageRef,
                    crop,
                    (blob) => {
                        this.setState({
                            channel_pic_square: blob
                        })
                    }
                );
            } else {
                this.getSquareCroppedImg(
                    this.imageRef,
                    crop,
                    (blob) => {
                        this.setState({
                            channel_pic_square: blob
                        })
                    }
                );
            }
        }
    }

    getSquareCroppedImg(image, crop, callback) {

        const canvas = document.createElement('canvas');
        canvas.setAttribute("id", "squareCanvasID");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        var originWidth = crop.width * scaleX;
        var originHeight = crop.height * scaleY;
        // maximum width/height
        var maxWidth = 1200, maxHeight = 1200;
        var targetWidth = originWidth,
            targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
        }
        // set canvas size
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext('2d');
        let imageMid = crop.width / 2;
        const newXpos = (crop.width * scaleX - crop.height * scaleY) / 2;

        let newImageDimension = {
            image,
            srxX: crop.x * scaleX + newXpos,
            srcY: crop.y * scaleY,
            srcW: crop.width * scaleX,
            srcH: crop.height * scaleY,
            dstX: 0,
            dstY: 0,
            dstW: targetWidth,
            dstH: targetHeight
        };

        vuePayLog("ChannelPictureModal", "getSquareCroppedImg", newImageDimension);

        ctx.drawImage(
            newImageDimension.image,
            newImageDimension.srxX,
            newImageDimension.srcY,
            newImageDimension.srcW,
            newImageDimension.srcH,
            newImageDimension.dstX,
            newImageDimension.dstY,
            newImageDimension.dstW,
            newImageDimension.dstH
        );

        let base64Image = canvas.toDataURL('image/jpeg', 1.0);
        getBlob(canvas, callback)
    }

    getCroppedImg(image, crop, callback) {

        const canvas = document.createElement('canvas');
        canvas.setAttribute("id", "rectangleCanvasID");

        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        var originWidth = crop.width * scaleX;
        var originHeight = crop.height * scaleY;
        // maximum width/height
        var maxWidth = 1200, maxHeight = 1200 / (16 / 9);
        var targetWidth = originWidth,
            targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
        }
        // set canvas size
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        // canvas.width = crop.width;
        // canvas.height = crop.height;

        const ctx = canvas.getContext('2d');

        let newImageDimension = {
            image,
            srxX: crop.x * scaleX,
            srcY: crop.y * scaleY,
            srcW: crop.width * scaleX,
            srcH: crop.height * scaleY,
            dstX: 0,
            dstY: 0,
            dstW: targetWidth,
            dstH: targetHeight
        };

        vuePayLog("ChannelPictureModal", "getCroppedImg", newImageDimension);

        ctx.drawImage(
            newImageDimension.image,
            newImageDimension.srxX,
            newImageDimension.srcY,
            newImageDimension.srcW,
            newImageDimension.srcH,
            newImageDimension.dstX,
            newImageDimension.dstY,
            newImageDimension.dstW,
            newImageDimension.dstH
        );

        let base64Image = canvas.toDataURL('image/jpeg', 1.0);
        getBlob(canvas, callback)
    }

    isImageValid = () => {
        if (this.props.type === "broadcaster_channel_image") {
            return (
                typeof this.state.channel_pic_square !== 'undefined' &&
                this.state.channel_pic_square !== null &&
                typeof this.state.channel_pic_rectangle !== 'undefined' !== undefined &&
                this.state.channel_pic_rectangle !== null
            )
        } else {

            return (
                typeof this.state.channel_pic_square !== 'undefined' &&
                this.state.channel_pic_square !== null
            )
        }
    };

    /**
     * @function make webservice call to upload the channel image
     * @param blob
     */
    uploadChannelImage = () => {
        if (this.isImageValid()) {
            const formData = new FormData();
            if (this.props.type === "broadcaster_channel_image") {
                formData.append("channel_pic_square", this.state.channel_pic_square);
                formData.append("channel_pic_rectangle", this.state.channel_pic_rectangle);
            } else {
                formData.append("profile_pic", this.state.channel_pic_square);
            }
            formData.append("device[platform]", this.props.device.platform);
            formData.append("device[name]", this.props.device.name);
            formData.append("device[version]", this.props.device.version);
            formData.append("device[ip]", this.props.device.ip);
            formData.append("device[id]", this.props.device.id);
            formData.append("device[app_version]", this.props.device.app_version);
            formData.append("device[device_token]", this.props.device.device_token);

            //dispatch an action to POST the channel picture/image to the Webservice
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        if (this.props.type === "broadcaster_channel_image") {
                            this.props.uploadChannelPicture(data.token, data.api_token, formData);
                        } else if (this.props.type === "broadcaster_profile_pic") {
                            this.props.uploadBroadcastProfilePicture(data.token, data.api_token, formData);
                        } else if (this.props.type === "user_profile_pic") {
                            this.props.uploadProfilePicture(formData, data.token, data.api_token);
                        }

                        this.setState({
                            channel_pic_square: null,
                            channel_pic_rectangle: null
                        })
                    }
                })
        }
    }


    render() {

        const {crop, src} = this.state;
        const btnPrimaryClass = className("btn", "btn-outline-primary", {"disabled": !this.isImageValid()});

        return (
            <div>

                <input ref='file'
                       type='file'
                       id={`${this.props.id}-file`}
                       accept="image/*"
                       style={{display: 'none'}}
                       onChange={this.onSelectFile}/>

                <div id={this.props.id} className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                     aria-hidden="true">
                    <div className="vertical-alignment-helper">
                        <div className="modal-dialog vertical-align-center">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {
                                        !(this.props.broadcasterChannelPicture.isFetching || this.props.broadcasterProfilePicture.isFetching || this.props.account_management.isFetching) &&
                                        <button type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                                onClick={() => {
                                                    hideModal(document.getElementById(this.props.id))
                                                }}>
                                            <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"}/>
                                        </button>
                                    }
                                </div>

                                <div className="modal-body">
                                    {src && (
                                        <ReactCrop
                                            src={src}
                                            crop={crop}
                                            circularCrop={this.props.type !== "broadcaster_channel_image"}
                                            onImageLoaded={this.onImageLoaded}
                                            onComplete={this.onCropComplete}
                                            onChange={this.onCropChange}
                                        />
                                    )}

                                </div>

                                <div className="modal-footer">
                                    <p>Please drag to adjust the image or resize</p>
                                    <button type="submit" className={btnPrimaryClass}
                                            onClick={this.uploadChannelImage}>
                                        {
                                            (this.props.broadcasterChannelPicture.isFetching || this.props.broadcasterProfilePicture.isFetching || this.props.account_management.isFetching)
                                                ?
                                                <img src={loading_white} alt={"Loading"} width={26}
                                                     height={26}/>
                                                :
                                                'SAVE'
                                        }
                                    </button>
                                    {
                                        !(this.props.broadcasterChannelPicture.isFetching || this.props.broadcasterProfilePicture.isFetching || this.props.account_management.isFetching) &&
                                        <a className="btn btn-link" data-dismiss="modal"
                                           onClick={() => {
                                               hideModal(document.getElementById(this.props.id))
                                           }}>Cancel
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        broadcasterProfilePicture: state.broadcasterProfilePicture,
        broadcasterChannelPicture: state.broadcasterChannelPicture,
        account_management: state.account_management,
        device: state.device.payload,
    };
}

export default connect(mapStateToProps, actions)(ChannelPictureModal);